import React from 'react'
import {
  Animation,
  Flex,
  Title,
  TabFooter,
  Button,
  SelectedItemsContainer,
} from 'styling/GlobalStyles'
import { CancelBtn } from 'components/Button/CancelBtn'
import { TriggersCollapseItem } from './IssueTriggersCollapseItem'
import { ItemsPick } from 'components/ItemsPick/ItemsPick'
import { IIssueTriggersTab } from 'types/issue-triggers.interface'

export const IssueTriggersProcessesTab = ({ state, setState, handleSubmit }: IIssueTriggersTab) => {
  const handleAdd = (item: any) => {
    setState((prev) => {
      const copy = { ...prev }
      const exists = copy.parentProcessTemplates.find((pt) => pt.id === item.id)
      if (exists) {
        copy.parentProcessTemplates = copy.parentProcessTemplates.filter((i) => i.id !== item.id)
      } else {
        copy.parentProcessTemplates.push(item)
      }
      return copy
    })
  }

  return (
    <Animation>
      <Flex between gap='2rem'>
        <SelectedItemsContainer>
          <Title pad='0 20px'>Selected Process Templates</Title>
          {state.parentProcessTemplates
            ?.filter((pt) => state.parentProcessTemplates.some((i) => pt.id == i.id))
            .map((item) => {
              return (
                <TriggersCollapseItem
                  prop='parentProcessTemplates'
                  setState={setState}
                  key={item.id}
                  data={item}
                />
              )
            })}
        </SelectedItemsContainer>
        <ItemsPick
          selectedList={state.parentProcessTemplates}
          handleAdd={handleAdd}
          link='process/template/company'
          placeholder='search process templates'
        />
      </Flex>
      <TabFooter>
        <Flex gap='1rem'>
          <CancelBtn />
          <Button orange onClick={handleSubmit}>
            Save
          </Button>
        </Flex>
      </TabFooter>
    </Animation>
  )
}
